import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'bam-cta-teaser-item',
  styleUrl: 'bam-cta-teaser-item.scss',
  shadow: false,
})
export class BamCtaTeaserItem {
  @Prop() isLight: boolean = false;
  @Prop() headline: string;
  @Prop() text?: string;
  @Prop() subline?: string;
  @Prop() optionalTitle?: string;
  @Prop() iconOrOffer?: 'iconCTA' | 'offerCTA';
  @Prop() image: boolean = false;
  @Prop() price?: string;
  @Prop() pricePrefix?: string;
  @Prop() showWidePicture?: boolean;
  @Prop() isRte?: boolean;
  @Prop() backgroundColor: 'white' | 'purple' | 'red' | 'green' | 'yellow';
  @Prop() isLeftAligned?: boolean = false;

  render() {
    const {
      iconOrOffer,
      text,
      subline,
      optionalTitle,
      price,
      pricePrefix,
      showWidePicture,
      image,
      headline,
      backgroundColor,
      isRte,
    } = this;
    return (
      <Host class='col'>
        <bal-card
          color={backgroundColor === 'white' ? backgroundColor : `${backgroundColor}-light`}
          class={{
            'cta-teaser-item__card': true,
          }}
        >
          <div class={{ 'cta-teaser-item__container': true, 'pt-none': showWidePicture }}>
            {(iconOrOffer === 'iconCTA' && image === true) &&
              <div class={{
                'cta-teaser-item__img-container mb-normal': true,
                'px-medium': !showWidePicture,
              }}>
                <slot name='image'></slot>
              </div>
            }
            <div class='cta-teaser-item__content-container'>
              {optionalTitle &&
                <bal-text class='mb-x-small px-medium' space='none' size='small'>{optionalTitle}</bal-text>}
              <bal-heading class='px-medium' level='h4' visual-level='h3' space='none'
                           subtitle={this.isLight}>{headline}</bal-heading>
              {(iconOrOffer === 'offerCTA' || text || subline || isRte) &&
                <bal-card-content class='mt-small'>
                  {iconOrOffer === 'offerCTA' &&
                    <div class='flex justify-content-center align-items-baseline'>
                      <bal-text class='inline-block mr-xx-small mt-xx-small' space='none'
                                size='lead'>{pricePrefix}</bal-text>
                      <bal-text class='inline-block' space='all' bold={true}><span
                        class='text-xx-large'>{price}</span></bal-text>
                    </div>
                  }
                  {text && <bal-text space='none'>{text}</bal-text>}
                  <slot name='richtext'></slot>
                  {subline &&
                    <bal-text
                      class={{
                        'mt-small': true,
                        'cta-teaser-item__left-align': this.isLeftAligned,
                        'cta-teaser-item__center-align': !this.isLeftAligned,
                      }}
                      space='none'>{subline}</bal-text>
                  }
                </bal-card-content>
              }
              <bal-card-action class='cta-teaser-item__actions mt-auto pt-large px-medium'>
                <slot name='actions'></slot>
              </bal-card-action>
            </div>
          </div>
        </bal-card>
      </Host>
    );
  }
}
